/* ============================================================
   Méga-menu — Natureluxy
   OUVERTURE AU SURVOL (hover), gérée entièrement en CSS.
   Ce script est volontairement neutre : il ne capture plus le clic
   sur les titres, afin de :
     - laisser le survol (CSS) ouvrir/fermer le panneau,
     - laisser le clic sur un titre suivre le lien de la collection parente,
     - éviter tout conflit hover / clic.
   (Fichier conservé pour ne pas casser l'inclusion dans le layout.)
   Mis à jour le: 2026-07-16
   ============================================================ */
(function () {
  'use strict';
  // Aucune logique JS nécessaire : l'ouverture au survol est 100% CSS.
  // Le fichier reste présent et inoffensif.
})();
